export const DEFAULT_SORT_ORDER = 'desc';

// sortKeyはDBのカラム名と一致させる必要があるため、スネークケースにする
export const PROJECT_DEFAULT_SORT_COLUMN = 'project_number';

export const MANHOUR_DEFAULT_SORT_ORDER = 'asc';
export const MANHOUR_DEFAULT_SORT_COLUMN = 'employee_code';

export const EMPLOYEE_DEFAULT_SORT_COLUMN = 'employee_code';
export const EMPLOYEE_SORT_ORDER = 'asc';

export const WORKINGTIME_DEFAULT_SORT_ORDER = 'desc';
export const WORKINGTIME_DEFAULT_SORT_COLUMN = 'date';

export const COST_ACCOUNTING_DEFAULT_SORT_COLUMN = 'e.start_date';
export const COST_ACCOUNTING_SORT_ORDER = 'desc';

export const REPORTSMANAGEMENT_DEFAULT_SORT_COLUMN = 'date';
export const REPORTSMANAGEMENT_DEFAULT_SORT_ORDER = 'desc';

export const BUSINESS_REPORT_DEFAULT_SORT_COLUMN = 'date';
